// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"_2Jqr_","img":"_2hVBK"};